import React, { FC } from 'react';
import { HashLink } from 'react-router-hash-link';

export interface AdminCategoryLink {
  children?: any;
  className?: string;
  onClick?: any;
  to: string;
}

export const AdminCategoryLink: FC<AdminCategoryLink> = ({ children, className, onClick, to }) => {
  return (
    <HashLink to={to} onClick={onClick} className={className}>
      {children}
    </HashLink>
  );
};
